import { HttpResponse } from 'msw'
import { restHandlerFactory } from 'src/tests/mocks/handlerFactory'

export const disableExplanationRevisionHandler = restHandlerFactory(
  '/trials/{trial_uid}/explanation_revisions/{explanation_revision_uid}/disable',
  'put',
  () => {
    return HttpResponse.json(undefined, { status: 204 })
  },
)
